export default __webpack_public_path__ + "static/3-6f8040820e130fc397f65af3cc9f261b.png";